import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';

export const useGetMaterialOrders = (closedOrders: boolean, dateFrom: Date | null) => {
    const { data, isLoading } = useQuery({
        queryKey: ['material-orders-orders', closedOrders, dateFrom],
        queryFn: async () => await apiClient.get(`material-order/list`,
            {
                params: {
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : ''
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
